import styled, { AnyStyledComponent } from 'styled-components';
import { ComponentColorsSolidLight, ComponentColorsSolidDark } from '../../style/colors.map';
import FONTS from '../../style/fonts';
import Button from '../Button/button';
import { TagStyles, TagProps, IndividualTagColorShape, TagColorsShape } from './tag.types';
import { MLBTheme } from '../../style/theme.types';
import COLORS from '../../style/universal.color';
import color from 'color';

const { mlbWhite, taglinkBlueOnDark } = COLORS;

const linkBlueOnDarkOverride:IndividualTagColorShape = {
  linkBlueOnDark: {
    color: mlbWhite,
    backgroundColor: taglinkBlueOnDark,
    hoverBackgroundColor: taglinkBlueOnDark
  }
};

const TagColors: TagColorsShape = {
  dark: {...ComponentColorsSolidDark, ...linkBlueOnDarkOverride },
  light: ComponentColorsSolidLight
};

const retrieveTagStylesType: Function = (style: string): string => {
  switch (style) {
    case TagStyles.DEFAULT:
      return 'default';
    case TagStyles.TICKET_LINK_GREEN:
      return 'ticketGreen';
    case TagStyles.MLB_TV_ORANGE:
      return 'mlbTvOrange';
    case TagStyles.LINK_BLUE_DARK:
        return 'linkBlueOnDark';
    default:
      return 'linkBlue';
  }
};

export const getColor: Function = (theme: MLBTheme , styleColor: TagStyles, highlightColor: Boolean) => {
  const mode: string = theme.dark ? 'dark' : 'light';
  let colorDef = TagColors[mode][retrieveTagStylesType(styleColor)];
  if (highlightColor === false) {
    return colorDef;
  }

  let override = {color: colorDef.backgroundColor, backgroundColor: color(colorDef.backgroundColor).mix(color('white'), 0.95).hex()};
  return {...colorDef, ...override};
}


export const Wrapper: AnyStyledComponent = styled.span`
  font-family: ${FONTS.primaryFont};
  text-align: center;
  width: auto;
  display: inline-block;
  border-radius: 4px;
  font-weight: 400;

  ${(props: TagProps) => {
    const { theme, color, highlightColor = false, hasRemoveButton } = props;
    const colorDef = getColor(theme, color, highlightColor, hasRemoveButton);
    const sylesProps = {
      padding: hasRemoveButton ? '4px 6px 4px 4px' : '2px 4px;',
      fontSize: hasRemoveButton ? '11px' : '12px',
      fontWeight: hasRemoveButton ? '400' : '700'
    }
    return {...sylesProps, ...colorDef};
  }};
`;

export const RemoveButton: AnyStyledComponent = styled(Button)`
  &&& {
    width: 12px;
    height: 12px;
    padding: 0 4px 0 6px;
    box-sizing: border-box;
    background: transparent;
  }
`;
